module.exports = __webpack_public_path__ + "img/app-jewelry-ecom.4a72c68b.png";